// Pure transform for CSV-imported contact rows, extracted so it's unit-tested
// without the importer UI.
//
// The "Subscriptions" column is an optional comma-separated list of contact-list
// names. It may be absent entirely (undefined) — guarding that was a past crash
// fix — and may contain blanks (e.g. trailing commas) we must drop so we don't
// create empty lists.
export function normalizeImportRows(rows) {
  return (rows || []).map((row) => ({
    ...row,
    subscriptions: (row.subscriptions || "")
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
      .map((s) => ({ list_name: s })),
  }));
}
